import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { Utils, NavigateTo } from '../../Utils.js';
import Form from '../Forms/Form/Form.js';
import CheckoutDelivery from '../CheckoutDelivery/CheckoutDelivery.js';
import CheckoutPayment from '../CheckoutPayment/CheckoutPayment.js';
import CheckoutLoyalty from '../CheckoutLoyalty/CheckoutLoyalty.js';
import './CheckoutSummary.css';
import { withAppContext, ModalsContext } from '../../contexts/AppContext';

class CheckoutSummary extends React.Component {
  static contextType = ModalsContext;

  state = {
    redirect: false,
  };

  constructor(props) {
    super(props);
    
    this.appRef = this.props.appContext.appRef;
    this.formRef = React.createRef();
    
  }

  hiddens = {
    // Hidden mezők ide jönnek
  };

  // Block code-ok, amelyek ne summary módban jelenjenek meg
  // Példák: 'personal_datas_block'
  summaryExcludedBlocks = [
    'aszf_checkbox_datas_block',
    'comment_datas_block',
  ];

  // Mezők, amelyek ne jelenjenek meg a summary nézetben, de a form elküldésekor benne legyenek
  // Példák: 'postal_address_int_1'
  summaryExcludedFields = [
    'postal_address_int',
    'is_company_blob',
    'select_address_button_B',
    'select_address_button_P'
  ];

  /**
   * Loyalty checkbox változás kezelése
   */
  handleLoyaltyChange = (checked) => {
    // Újratöltjük a formot a frissített adatokkal
    if (this.formRef.current) {
      this.formRef.current.load_form_data(true);
    }
  }

  /**
   * Form hívja meg ha változás történt egy mezőben
   */
  on_form_change(key, value) {

    if (['is_company_blob', 'postal_address_int'].includes(key) || key.startsWith('select_address_button_')) {
      if (this.formRef.current) {
        this.formRef.current.load_form_data(true);
      }
    }
  }

  /**
   * Form hívja meg amikor egy blokk mentése történik
   */
  on_block_save(blockData, formData) {

    // Ha a blokkban van stepnumber, akkor beállítjuk a multi_steps_checkout paramétereket
    if (blockData && blockData.stepnumber) {
      formData.multi_steps_checkout_step_number = blockData.stepnumber;
      formData.multi_steps_checkout_sending_order_next_x = 1;
    }
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    // Kosár tartalmának frissítése sikeres rendelés leadás után
    if (this.appRef?.current) {
      this.appRef.current.get_update_shopping_cart(null, false);
    }

    //ha olyan fizetési mód ahol formot kell submitolni
    //@todo itt még le kell kezelni ha másfajta fizetési mód lesz hogy ne csak a payu formot nézze
    if (params.result.bank_content && params.result?.bank_content.length>0)
    {
      const parseHtml = html => new DOMParser().parseFromString(html, 'text/html').body.innerHTML;

      const bankContentElement = document.getElementById('checkout_summary_bank_content');
      
      bankContentElement.innerHTML = parseHtml(params.result.bank_content); 
      
      const payuForm = document.getElementById("PayUForm");

      if (payuForm) {
        payuForm.submit();
        return;
      }

      const borgunForm = document.getElementById("BorgunForm");
      

      if (borgunForm) {
        borgunForm.submit();
        return;
      }
    } 
  }

  /**
   * Összesítő blokk renderelése
   */
  renderCheckoutSummaryBlock = (props) => {
    const response = props.fullFormResponse || {};
    const payment_delivery_methods = response.payment_delivery_methods || {};
    const shopping_cart = response.shopping_cart || {};
    const payment_method = payment_delivery_methods.payment_method_id ? payment_delivery_methods.payment_methods[payment_delivery_methods.payment_method_id] : null;
    const delivery_method = payment_delivery_methods.delivery_method_id ? payment_delivery_methods.delivery_methods[payment_delivery_methods.delivery_method_id] : null;
    const logistic_cost = delivery_method ? delivery_method.logistic_cost_gross : 0;
    const sumtotal_gross = shopping_cart.sum_total_gross + (payment_delivery_methods.delivery_cost_gross || 0) + (payment_method ? payment_method.cost_gross : 0);
    const coupon_number = shopping_cart.discounts?.coupon_system?.coupon_number ? shopping_cart.discounts.coupon_system.coupon_number : '';
    const coupon_label =  shopping_cart.discounts?.coupon_system?.coupon_label ? shopping_cart.discounts.coupon_system.coupon_label : 'Kupon';
    const coupon_gross = shopping_cart.discounts?.coupon_system?.coupon_gross ? shopping_cart.discounts.coupon_system.coupon_gross : 0;

    return <div className='form_block_summary checkout_summary_datas_block'>
      <div className='block_header'>
        <div className="block_title">
          <span>{i18n.t('checkoutSummaryTotalLabel')}</span> 
          <span>{Utils.format_currency(sumtotal_gross, this.appRef.current.currency_settings)}</span>
        </div>
      </div>
      <div className='summary_content'>
          <div className='summary_row'>
            <span className='summary_label'>{i18n.t('checkoutSummaryProductsTotal')}</span>
            <span className='summary_value'>{Utils.format_currency(shopping_cart.sum_total_gross, this.appRef.current.currency_settings)}</span>
          </div>
          {shopping_cart.discounts?.loyalty_points_system?.use_loyalty_points>0 && <div className='summary_row'>
            <span className='summary_label'>{i18n.t('checkoutSummingUsedLoyaltyPoints')}</span>
            <span className='summary_value'>-{Utils.format_currency(shopping_cart.discounts?.loyalty_points_system?.use_loyalty_points, this.appRef.current.currency_settings)}</span>
          </div>}
          {coupon_gross > 0 && <div className='summary_row'>
            <span className='summary_label'>{coupon_label}:</span>
            <span className='summary_value'>-{Utils.format_currency(coupon_gross, this.appRef.current.currency_settings)}</span>
          </div>}
          {delivery_method && delivery_method.cost_gross>0 && <div className='summary_row'>
            <span className='summary_label'>{delivery_method.delivery_cost_name}:</span>
            <span className='summary_value'>{Utils.format_currency(payment_delivery_methods.delivery_cost_gross - logistic_cost, this.appRef.current.currency_settings)}</span>
          </div>}
          {logistic_cost > 0 && <div className='summary_row'>
            <span className='summary_label'>{i18n.t('checkoutSummaryLogisticCost')}</span>
            <span className='summary_value'>{Utils.format_currency(logistic_cost, this.appRef.current.currency_settings)}</span>
          </div>}
          {payment_method!==null && payment_delivery_methods.payment_cost_gross>0 && <div className='summary_row'>
            <span className='summary_label'>{payment_method.payment_cost_name || payment_method.payment_method || i18n.t('checkoutCodDefaultLabel')}:</span>
            <span className='summary_value'>{Utils.format_currency(payment_delivery_methods.payment_cost_gross, this.appRef.current.currency_settings)}</span>
          </div>}
      </div>
    </div>
  }

  render() { 
    

    const { isEmbedded } = this.props;

    return (
      <div className="checkout_summary_embedded">
        <div className="form_wrapper">
          <Form 
            loader={true}
            summaryMode={true}
            summaryExcludedBlocks={this.summaryExcludedBlocks}
            summaryExcludedFields={this.summaryExcludedFields}
            customBlocks={{
              'delivery_methods_datas_block': CheckoutDelivery,
              'payment_methods_datas_block': CheckoutPayment,
              'checkout_summary_datas_block': this.renderCheckoutSummaryBlock,
              'checkout_user_loyalty_block': CheckoutLoyalty
            }}
            customBlocksProps={{
              'checkout_user_loyalty_block': {
                onLoyaltyChange: this.handleLoyaltyChange,
                appRef: this.appRef
              }
            }}
            onSuccess={(params) => {this.on_submit_success(params)}} 
            onBlockSave={(blockData, formData) => {this.on_block_save(blockData, formData)}}
            onBeforeSubmit={(formData) => {
              formData.multi_steps_checkout_step_number = 6;
              formData.multi_steps_checkout_sending_order_next_x = 1;
              return formData;
            }}
            ref={this.formRef} 
            hiddens={this.hiddens} 
            name="checkout" 
            submit_text={i18n.t('checkoutSubmit')} 
            parent={this} 
          />
        </div>
        <div id="checkout_summary_bank_content"></div>
      </div>
    );
    
  }
}

export default withAppContext(CheckoutSummary);